import { CalendarCheck, HomeIcon, Smile } from "lucide-react";
import { HOW_IT_WORKS } from "@/lib/site-data";

const ICONS = [CalendarCheck, HomeIcon, Smile];

export default function HowItWorks() {
  return (
    <section id="process" className="py-20 md:py-28 bg-brand-muted/60" data-testid="how-it-works">
      <div className="container-site">
        <div className="max-w-2xl">
          <p className="overline mb-3">How it works</p>
          <h2 className="font-serif text-4xl md:text-5xl text-brand-pine leading-tight">
            A clinic at your doorstep — <span className="italic text-brand-clay">in three simple steps.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {HOW_IT_WORKS.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={s.num}
                data-testid={`how-step-${i}`}
                className="relative bg-white rounded-2xl p-7 border border-brand-line/60 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 rounded-full bg-brand-clay/10 flex items-center justify-center text-brand-clay">
                    <Icon size={22} strokeWidth={1.5} />
                  </div>
                  <span className="font-serif text-5xl text-brand-muted leading-none">
                    {s.num}
                  </span>
                </div>
                <h3 className="font-serif text-2xl text-brand-pine mb-2">{s.title}</h3>
                <p className="text-sm text-brand-textMuted leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
